export default __webpack_public_path__ + "static/media/smily.e34cb039.svg";